// Clean task name to remove "&" and HTML entities - AGGRESSIVE CLEANING
export function cleanTaskName(name) {
  if (!name) return name;
  let cleaned = String(name);
  
  // FIRST: Remove all "&" characters immediately (most aggressive)
  cleaned = cleaned.replace(/&/g, "");
  
  // Remove HTML entities (without the & now)
  cleaned = cleaned.replace(/amp;/g, "");
  cleaned = cleaned.replace(/nbsp;/g, " ");
  cleaned = cleaned.replace(/lt;/g, "");
  cleaned = cleaned.replace(/gt;/g, "");
  cleaned = cleaned.replace(/quot;/g, "");
  cleaned = cleaned.replace(/#39;/g, "");
  cleaned = cleaned.replace(/#x27;/g, "");
  cleaned = cleaned.replace(/#x2F;/g, "/");
  
  // Remove any weird spacing/formatting characters that cause letter spacing issues
  cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, ""); // Zero-width spaces
  cleaned = cleaned.replace(/[\u00A0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/g, " "); // Various space types
  
  // Remove any invisible or problematic Unicode characters
  cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g, "");
  
  // Remove leading/trailing whitespace and normalize multiple spaces
  cleaned = cleaned.trim();
  cleaned = cleaned.replace(/\s+/g, " ");
  
  return cleaned;
}

// Remove "&" from text - ULTRA AGGRESSIVE CLEANING (for PDF)
export function cleanTextForPDF(text) {
  if (!text) return "";
  let cleaned = String(text);
  
  // Remove ALL variants of ampersand characters (regular, Unicode, HTML entities)
  cleaned = cleaned.replace(/&/g, ""); // Regular ampersand
  cleaned = cleaned.replace(/\u0026/g, ""); // Unicode ampersand
  cleaned = cleaned.replace(/\uFF06/g, ""); // Full-width ampersand
  cleaned = cleaned.replace(/\uFE60/g, ""); // Small ampersand
  cleaned = cleaned.replace(/＆/g, ""); // Full-width variant
  
  // Remove HTML entities (without the &)
  cleaned = cleaned.replace(/amp;/gi, "");
  cleaned = cleaned.replace(/nbsp;/gi, " ");
  cleaned = cleaned.replace(/lt;/gi, "");
  cleaned = cleaned.replace(/gt;/gi, "");
  cleaned = cleaned.replace(/quot;/gi, "");
  cleaned = cleaned.replace(/#39;/gi, "");
  cleaned = cleaned.replace(/#x27;/gi, "");
  cleaned = cleaned.replace(/#x2F;/gi, "/");
  
  // Remove any weird spacing/formatting characters that cause letter spacing issues
  cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, ""); // Zero-width spaces
  cleaned = cleaned.replace(/[\u00A0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/g, " "); // Various space types
  
  // Remove any invisible or problematic Unicode characters
  cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g, "");
  
  // Normalize multiple spaces to single space
  cleaned = cleaned.replace(/\s+/g, " ");
  
  // Trim and return
  return cleaned.trim();
}

